import { Card, Title, Pill, NoContent } from '@chillibean/component-library/legacy';
import pluralize from 'pluralize';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Reporting } from '../../../api/reporting/reporting';
import useHttpRequest from '../../../CustomHooks/useHttpRequest/useHttpRequest';
import LogAndDisplayError from '../../../LogAndDisplayError/LogAndDisplayError';

function FormReportTemplateList() {
  const history = useHistory();

  const {
    state: { status, data, error },
    fetchRequest,
  } = useHttpRequest();

  useEffect(() => {
    if (status === 'idle') {
      fetchRequest(Reporting.formTemplates());
    }
  });

  const onClickCallback = (formTemplateId) => history.push(`/forms/templates/${formTemplateId}/forms`);

  const nonDraftFormTemplates = data?.form_templates.filter((formTemplate) => formTemplate.number_of_forms > 0);

  const FormTemplateCards = () => {
    return nonDraftFormTemplates.map((formTemplate) => (
      <Card
        headingIcon="renameBox"
        heading={formTemplate.title}
        subheading={formTemplate.id.toString()}
        key={formTemplate.id.toString()}
        active
        clickHandler={() => onClickCallback(formTemplate.id)}
      />
    ));
  };

  if (status === 'error') {
    if (error.response.status === 403) {
      return (
        <>
          <Title heading="Forms Reporting" subheading="" />
          <div className="header-wrapper-form-report-no-content">
            <NoContent> Form Templates are not currently enabled on this trial</NoContent>
          </div>
        </>
      );
    }
    return <LogAndDisplayError error={error} />;
  }

  return (
    <>
      <div className="header-wrapper-formReportList">
        <Title heading="Forms Reporting" subheading="" loading={status !== 'resolved'} />
        <Pill
          dataCount={status !== 'resolved' ? '' : String(nonDraftFormTemplates?.length)}
          dataContext={pluralize('Form Template', nonDraftFormTemplates?.length)}
          loading={status !== 'resolved'}
        />
      </div>
      <div className="formTemplates-overflow">
        {status !== 'resolved' ? [...Array(4).keys()].map((key) => <Card key={key} loading />) : <FormTemplateCards />}
        <div className="spacing" />
      </div>
    </>
  );
}

export default FormReportTemplateList;
